import styled from 'styled-components';

import { fontSizes, fontWeights, zIndexes } from '../../theme';
import colors from '../../theme/constants/colors';
import { hexWithOpacity } from '../../utils';

export const Container = styled.div`
  position: fixed;
  z-index: ${zIndexes.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: ${hexWithOpacity(colors.navy, 0.8)};
`;

export const Title = styled.h3`
  margin-bottom: 46px;
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.xl};
  text-align: center;
`;

export const Content = styled.div.attrs({
  'aria-modal': 'true',
  role: 'dialog',
})`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px;
  background-color: ${colors.pearl};
  border-radius: 20px;
  box-shadow: 4px 4px 20px ${hexWithOpacity(colors.navy, 0.1)};
`;
